import cc from "classcat";

import styles from "./CardImage.module.scss";
import { CardThumbnailProps } from "./types";

const CardThumbnail = ({ image, size = "small" }: CardThumbnailProps) => (
  <div
    className={cc([
      styles.cardContainer,
      size === "large" ? styles.large : styles.small,
      styles.cardSvg,
    ])}
    style={{
      backgroundImage: `url('${image}')`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    }}
  />
);

export default CardThumbnail;
